import CandidatesIcon from 'assets/images/iPrise/Candidates.svg';
import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import ReportsIcon from 'assets/images/iPrise/Reports.svg';
import SystemIcon from 'assets/images/iPrise/System.svg';
import TeamIcon from 'assets/images/iPrise/Team.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const ManagementHeader: React.FC = () => {
  const navItems: NavItem[] = [
    { icon: TeamIcon, label: 'Team', path: '/management/teams' },
    { icon: JobQueueIcon, label: 'Job Queue', path: '/management/job-queue' },
    {
      icon: CandidatesIcon,
      label: 'Candidates',
      path: '/management/candidates',
    },
    { icon: ReportsIcon, label: 'Reports', path: '/management/reports' },
    { icon: SystemIcon, label: 'System', path: '/management/system' },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/management/profile"
      basePath="/management"
    />
  );
};

export default ManagementHeader;
